import { useEffect } from 'react';
import { Button } from '@/ui/components/Button';
import { useTerms } from '../../hooks/useTerms';
import { useNavigate } from 'react-router-dom';
import styles from './BcTermsPage.module.scss';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { Icon } from '@/ui/icons/Icon';

function BcTermsPage() {
  const navigate = useNavigate();
  const { getBcTerms, bcTerms, isLoading, setAcceptedTerms } = useTerms();

  useEffect(() => {
    getBcTerms();
  }, []);

  const handleContinue = () => {
    setAcceptedTerms({
      bc: true,
    });
    navigate(-1);
  };

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.termsContainer}>
          <h1 className={styles.title}>
            Acordul explicit pentru interogarea la Biroul de Credit
          </h1>

          <textarea
            id="bc-terms"
            className={styles.termsText}
            value={bcTerms?.text || ''}
            readOnly
            placeholder="Se încarcă termenii și condițiile..."
          />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          trackingId="accept_bc_terms"
          variant="filled"
          text="Continuă"
          className={styles.button}
          onClick={handleContinue}
          rightIcon={<Icon name="arrow-right" />}
        />
      </div>
    </div>
  );
}

export default BcTermsPage;
